import React from 'react';
import ListOfOfflineTasks from 'offline_app/presentation/ListOfOfflineTasks';

const OfflineTasksWidget = () => {
    return <ListOfOfflineTasks />;
};

export default OfflineTasksWidget;
